export default __webpack_public_path__ + "static/media/iphone-hand-mockup.e93be17e.png";